module.exports = __webpack_public_path__ + "static/media/logo.41d887ae.svg";